export default {"src":"/_next/static/media/check.535905d1.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};